module.exports = __webpack_public_path__ + "img/dinkenclave-13.376d9890.jpeg";